






















































































































































































import { Vue, Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import DisplayMixin from '@/mixins/displayTitle'

const relatedDataList = [
  {
    name: '等级',
    value: 12
  },
  {
    name: '总兔币',
    value: 12
  },
  {
    name: '冻结兔币',
    value: 12
  },
  {
    name: '累计消耗积分',
    value: 12
  },
  {
    name: '注册天数',
    value: 12
  }
]
const permissionList = ['封锁账号', '禁言']
@Component({
  name: 'UserDetail'
})
export default class extends mixins(DisplayMixin) {
  relatedDataList = relatedDataList
  setting = {
    username: 'xxx',
    password: '',
    phone: '+86 13299923188',
    email: 'antdesign@alipay.com',
    isOpenPhoneLogin: false,
    isClearQuestion: false,
    isUnbind: false
  }
  permissionList = permissionList
  checkedPermissionList: string[] = []
}
